"use client";

import { forwardRef } from "react";
import { useTranslations } from "next-intl";
import { cn } from "@/lib/utils";
import {
  StatusToast,
  type StatusToastProps,
} from "@/components/ui/status-toast";

/**
 * An inline status message (error, warning, info…) in the SilverTiger status
 * toast style, as the internal admin's Wiki upload form shows its errors.
 *
 * It sits centered under the content it is about and is as wide as its text,
 * wrapping only at the width of its container. It never closes by itself: an
 * error with `onDismiss` gets a close button, and otherwise the message lasts
 * as long as the state it describes.
 */
export const InlineStatus = forwardRef<HTMLDivElement, StatusToastProps>(
  function InlineStatus({ className, dismissLabel, ...props }, ref) {
    const t = useTranslations("InlineStatus");

    return (
      <StatusToast
        ref={ref}
        className={cn("mx-auto w-fit max-w-full", className)}
        dismissLabel={dismissLabel ?? t("dismiss")}
        {...props}
      />
    );
  },
);
